import type { Background } from '@/api/types/background'
import type { BackgroundsSort } from './types/backgrounds-sort'

export const BACKGROUNDS_SORT_DEFAULT: BackgroundsSort = 'newest'

export const BACKGROUNDS_SORT_OPTIONS: ReadonlyArray<{ value: BackgroundsSort; label: string }> = [
  { value: 'newest', label: 'Newest first' },
  { value: 'oldest', label: 'Oldest first' },
  { value: 'az', label: 'A to Z' },
  { value: 'za', label: 'Z to A' },
]

function compareDisplayName(left: string, right: string): number {
  return left.localeCompare(right, undefined, { sensitivity: 'base', numeric: true })
}

/**
 * Reorders backgrounds for the Sort control. Newest/Oldest sort by `jobYearStart` — the closest
 * analog to Photos' `uploadDate` (`sortTrayPhotos`), since a background has no per-item timestamp,
 * only the year range it was made available.
 */
export function sortBackgrounds(backgrounds: Background[], sort: BackgroundsSort): Background[] {
  return backgrounds
    .map((background, index) => ({ background, index }))
    .sort((left, right) => {
      let cmp = 0

      if (sort === 'az' || sort === 'za') {
        cmp = compareDisplayName(left.background.displayName, right.background.displayName)
        if (sort === 'za') cmp = -cmp
      } else if (sort === 'newest') {
        cmp = right.background.jobYearStart - left.background.jobYearStart
      } else {
        cmp = left.background.jobYearStart - right.background.jobYearStart
      }

      if (cmp !== 0) return cmp

      return left.index - right.index
    })
    .map(({ background }) => background)
}
